export interface IAuthConfig {
  clientId: string;
  realm: string;
  url: string;
  loginUrl?: string;
  logoutUrl?: string;
  frameUrl?: string;
}


export interface IDoLoginRequest {
  userName: string;
  redirectUri: string;
}


export enum LoginActionType {
  Error,
  Redirect,
  MultipleOrganisation
}

export interface IDoLoginResponse {
  actionType: LoginActionType;
  payload?: any;
}

export interface IUserInfoDTO {
  name: string;
  organisation: {
    name: string;
    logo: string;
  }
}


export interface IRegisterRequest {
  organisationName: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  logo: string;
}

export interface IUserDTO {
  id: string;
  createdTimestamp: number;
  enabled: boolean;
  emailVerified: boolean;
  firstName: string;
  lastName: string;
  email: string;
}
